import { QueryParams } from "../types";

export const searchStringToParams = (search: string) => {
  let result = {} as QueryParams;

  if (search[0] === "?") {
    search = search.replace("?", "");
  }

  if (!search.length) {
    return result;
  }

  const segments = search.split("&");

  for (const segment of segments) {
    const [key, value] = segment.split("=");
    result = appendQueryParam(result, key, decodeURIComponent(value));
  }

  return result;
};

export const paramsToSearchString = (
  params: QueryParams,
  prefix: string = "?"
) => {
  // see https://stackoverflow.com/a/62969380/498111
  let delim = prefix;
  let outStr = "";

  const append = (key: string, value: number | string | boolean) => {
    if (value === undefined) return;
    outStr = `${outStr}${delim}${encodeURIComponent(key)}=${encodeURIComponent(
      value
    )}`;
    delim = "&";
  };

  for (const key in params) {
    const value = params[key];
    if (Array.isArray(value)) {
      for (const arrayItemValue of value) {
        append(key, arrayItemValue);
      }
    } else {
      append(key, value);
    }
  }
  return outStr;
};

export const appendQueryParam = (
  params: QueryParams,
  key: string,
  value: any
) => {
  const result = { ...params };

  if (key in result) {
    if (!Array.isArray(result[key])) {
      // if we see a second identical query term, then this is an array of values,
      //  so transform the existing value to an array ...
      result[key] = [result[key]];
    }
    result[key] = [...result[key], value];
  } else {
    result[key] = value;
  }

  return result;
};

// note: if the param is not an array param then value is ignored
//  i.e. removeQueryParam({foo: "bar"}, "foo", "baz") will still remove foo
export const removeQueryParam = (
  params: QueryParams,
  key: string,
  value?: any
) => {
  if (!(key in params)) {
    return { ...params };
  }

  if (Array.isArray(params[key])) {
    const nextArray = (params[key] as any[]).filter((item) => item !== value);
    return {
      ...params,
      [key]:
        nextArray.length === 1
          ? nextArray[0] // demote the value from an array to a one-to-one value
          : nextArray,
    };
  }

  return {
    ...params,
    // we set this as undefined, rather than remove it, so that subsequent logic
    //  which may attempt to splice the old params with the new params knows that this
    //  key has been wiped.  Final logic will remove the param from the query string.
    [key]: undefined,
  };
};

export const ensureParamIsArray = (param: any) =>
  param === undefined ? [] : Array.isArray(param) ? param : [param];
